/**
 * 中身が空の店舗カラムを削除 ＆ ミスで増えた空のdt・dd・pタグを自動消去する
 */
export function handleEmptyShopColumns() {
	// 対象のコラム（swell-block-column）を全部取得
	const columns = document.querySelectorAll(".p-company-overview__storeList .swell-block-column");

	columns.forEach((column) => {
		// 1. 各 dd の中身（空のpタグなど）を大掃除
		const dds = column.querySelectorAll(".swell-block-dl__dd");
		dds.forEach((dd) => {
			// 先に dd の中にある「空っぽの p タグ」を削除
			const ps = dd.querySelectorAll("p");
			ps.forEach((p) => {
				if (p.textContent.trim() === "") {
					p.remove();
				}
			});

			// 空になった、または最初から空の dd を削除
			if (dd.textContent.trim() === "") {
				dd.remove();
			}
		});

		// 2. 💡 追加：空っぽの dt をピンポイントで大掃除
		const dts = column.querySelectorAll(".swell-block-dl__dt");
		dts.forEach((dt) => {
			if (dt.textContent.trim() === "") {
				dt.remove(); // 💡 文字の入っていない店舗名（dt）を消去
			}
		});

		// 3. カラム全体の最終有効データ判定（残った dt があるかチェック）
		// ※ステップ2で空の dt を消した後の最新状態を再取得する
		const activeDts = column.querySelectorAll(".swell-block-dl__dt");
		let hasValidData = false;

		activeDts.forEach((dt) => {
			if (dt.textContent.trim() !== "") {
				hasValidData = true;
			}
		});

		// 有効な店舗名データが1つも残らなかった場合、カラムごとDOMから削除
		if (!hasValidData) {
			column.remove();
		}
	});
}
